import React from 'react';
import AppRoutes from '../routes';
import Footer from '../components/ydnm/footer';
import Header from '../components/ydnm/header';
import HomePage from '../pages/ydnm/home_page';
import ArtistPage from '../pages/ydnm/artist_page';
import PricingPage from '../pages/ydnm/pricing_page';

export default function YdnmTemplate(props) {
    return (
        <React.Fragment>
            <Header />
            <AppRoutes
                homePage={HomePage}
                artistPage={ArtistPage}
                pricingPage={PricingPage}
            />
            <Footer />
        </React.Fragment>
    )
}
